import { createFileRoute } from "@tanstack/react-router";
import { LeaderboardView } from "@/lib/features/LeaderboardView";
export const Route = createFileRoute("/_app/topplista/")({
  component: LeaderboardView
});